import React from "react";
import { useAuth } from "../context/AuthContext";

export default function SubscriptionNotice() {
  const { subscription, subscriptionError, billingState, refreshUser, billingBusy } = useAuth();
  return <div aria-live="polite" className="text-sm space-y-2">
    {subscriptionError && <p role="alert">{subscriptionError} <button className="underline" disabled={billingBusy}
      onClick={() => refreshUser().catch(() => {})}>Réessayer</button></p>}
    {(billingState?.problem || billingState?.pending) && <p role="status">{billingState.problem || "Paiement en attente. Les droits seront activés après confirmation."}</p>}
    {(subscription?.subscriptions || []).filter((s) => s.active && s.pending_plan).map((s) => <p key={s.provider}>
      Forfait {s.pending_plan.toUpperCase()} prévu{s.pending_effective_at ? ` à partir du ${new Date(s.pending_effective_at).toLocaleDateString()}` : " au prochain renouvellement"}.
    </p>)}
  </div>;
}
